/**
 * @generated SignedSource<<854957ed3bdd04c4b87ebf70a3facc89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsSelection_component$data = {
  readonly downloadOverview: {
    readonly " $fragmentSpreads": FragmentRefs<"FundsListDownload_fundsListDownload">;
  } | null | undefined;
  readonly fundstable: {
    readonly " $fragmentSpreads": FragmentRefs<"FundsTable_table">;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "FundsSelection_component";
};
export type FundsSelection_component$key = {
  readonly " $data"?: FundsSelection_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsSelection_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsSelection_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FundsTable",
      "kind": "LinkedField",
      "name": "fundstable",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FundsTable_table"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SimpleLink",
      "kind": "LinkedField",
      "name": "downloadOverview",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FundsListDownload_fundsListDownload"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FundsSelection",
  "abstractKey": null
};

(node as any).hash = "a9d0eda4ea603203d1f5ecd57ed0d2b5";

export default node;
